module.exports = __webpack_public_path__ + "static/media/skin-cancer-detection-app.53d74a5d.png";